export default __webpack_public_path__ + "static/media/2026_Senthilnathan_et_al_2026_PlantSoil.283cddef.pdf";